import RouteConst from 'constants/RouteConst'
import React, { Component } from 'react'
import { isObjectEmpty } from 'utilities/JSUtil'
import './UserError.scss'
/**
 * Component which is displayed when there are user permission errors
 */
export class UserError extends Component {

    constructor(props) {
        super(props)
        const user = this.props.history.location?.state?.user || {}

        if (isObjectEmpty(user)) {
            this.props.history.push(RouteConst.ROUTE_HOME_PAGE)
        }

        this.state = {
            user: user
        }
    }

    render() {
        return (
            <div id='user-error' className='user-error'>
                The user {this.state.user.username && <>({this.state.user.username})</>} does not have the required permissions.
                This system is used for onboarding new properties. If you are trying to onboard a new property, but the property 
                does not appear in this section, please contact your Onboarding Project Director or Choice assigned Opening associate. 
                If you are not currently onboarding a new Choice property, this system is not available.
            </div>
        )
    }
}

export default UserError